import { MonitoringHeader } from "./monitoring-header";

export function MonitoringSearchScreen() {
  return (
    <div className="flex min-h-screen flex-1 flex-col bg-grey-25">
      <MonitoringHeader />
      <NothingToShowBody />
    </div>
  );
}

function NothingToShowBody() {
  return (
    <div className="flex flex-1 flex-col items-center gap-4 border-l border-grey-300 px-4 pb-8 pt-40">
      <div className="flex w-[160px] flex-col gap-1.5">
        <div className="h-4 rounded-[4px] bg-grey-200" />
        <div className="h-4 rounded-[4px] bg-grey-200" />
        <div className="h-4 rounded-[4px] bg-grey-200" />
      </div>
      <div className="flex flex-col items-center gap-1.5">
        <p className="text-h4 text-black">Start a search</p>
        <p className="w-[200px] text-center text-small text-grey-900">Type a name to monitor.</p>
      </div>
    </div>
  );
}
